import React from 'react';
import { cn, getTierColor, getTierName } from '@/lib/utils';
import { Cpu, Zap, Cloud } from 'lucide-react';

const tierIcons = {
  tier1_local_fast: Cpu,
  tier2_local_smart: Zap,
  tier3_cloud: Cloud,
};

export function TierBadge({ tier, size = 'default', showLabel = true }) {
  const Icon = tierIcons[tier] || Cpu;
  const color = getTierColor(tier);
  const name = getTierName(tier);

  const sizeClasses = {
    sm: 'px-1.5 py-0.5 text-[10px]',
    default: 'px-2 py-1 text-xs',
    lg: 'px-3 py-1.5 text-sm',
  };

  const iconSizes = {
    sm: 'h-3 w-3',
    default: 'h-3.5 w-3.5',
    lg: 'h-4 w-4',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-sm font-mono font-medium border',
        sizeClasses[size]
      )}
      style={{
        backgroundColor: `${color}20`,
        color: color,
        borderColor: `${color}40`,
      }}
      data-testid={`tier-badge-${tier}`}
    >
      <Icon className={iconSizes[size]} />
      {showLabel && <span>{name}</span>}
    </span>
  );
}

export default TierBadge;
